<template>
  <div style="display:flex;flex-direction:row">
    <ag-grid-column-edit
      v-for="(item,index) in paramsArray"
      :key="index"
      :args="item"
      style="flex-grow:1"
    />
  </div>
</template>

<script>
export default {
  name: 'AgGridColumnEditGroup',
  data() {
    return {
      paramsArray: []
    }
  },
  created() {
    const custom = this.params.colDef.custom
    const isEdit = custom.isEdit || false
    for (const item of custom.childs) {
      this.paramsArray.push({
        colDef: {
          field: item.field,
          custom: { isEdit, ...item }
        },
        data: this.params.data
      })
    }
  }
}
</script>

<style>
</style>
